import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface unauthorizedHeaderTitle {
    header: string;
    [key: string]: string | null; // Generic object to store data for different pages
    parentRoute: string | null;
}

const initialState: unauthorizedHeaderTitle = {
    header: '',
    parentRoute: null,
};

export const unAtuthorizedHeaderTitleSlice = createSlice({
    name: 'unauthorizedHeaderTitle',
    initialState,
    reducers: {
        setUnauthorizedHeaderTitle: (state: any, action: any) => {
            
            state.header = action.payload.header;
            state.id = action.payload.id;
            state.parentRoute = action.payload.parentRoute;
        },
        setUnauthorizedPageData: (state, action: PayloadAction<{ page: string, id: string }>) => {
            
            state[action.payload.page] = action.payload.id;
        },
        clearUnauthorizedPageData: (state) => {
            Object.keys(state).forEach(key => {
                state[key] = null;
            });
        },

    },
});

// this is for dispatch
export const { setUnauthorizedHeaderTitle, setUnauthorizedPageData, clearUnauthorizedPageData }: any = unAtuthorizedHeaderTitleSlice.actions;

// this is for configureStore
export default unAtuthorizedHeaderTitleSlice.reducer;
